import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { css } from './css'

const CHAVE = 'walleon-cookies-consentimento'

export function CookieBanner() {
  const [mostrar, setMostrar] = useState(false)

  useEffect(() => {
    try { setMostrar(!localStorage.getItem(CHAVE)) } catch { setMostrar(true) }
  }, [])

  function escolher(valor: 'todos' | 'essenciais') {
    try { localStorage.setItem(CHAVE, valor) } catch { /* navegação privada: só não persiste entre sessões */ }
    setMostrar(false)
  }

  if (!mostrar) return null

  return (
    <div style={css('position: fixed; left: 0; right: 0; bottom: 0; z-index: 50; background: #131B2C; border-top: 1px solid rgba(255,255,255,0.1); box-shadow: 0 -8px 30px rgba(0,0,0,0.4);')}>
      <div style={css('max-width: 1200px; margin: 0 auto; padding: 20px 32px; display: flex; align-items: center; gap: 24px; flex-wrap: wrap;')}>
        <p style={css('margin: 0; flex: 1; min-width: 260px; color: #DCE1EC; font-size: 13px; line-height: 1.6;')}>
          Usamos cookies para o funcionamento essencial do site e, com sua permissão, para entender como ele é usado e melhorar sua experiência.
          Você pode gerenciar suas preferências a qualquer momento. Saiba mais na nossa{' '}
          <Link to="/cookies" style={css('color: #F5A623; text-decoration: none;')}>Política de Cookies</Link>, em conformidade com a Lei Geral de Proteção de Dados (LGPD).
        </p>
        <div style={css('display: flex; gap: 10px; flex-shrink: 0;')}>
          <button onClick={() => escolher('essenciais')} style={css('background: transparent; border: 1px solid rgba(255,255,255,0.18); color: #DCE1EC; font-weight: 600; font-size: 13px; padding: 10px 18px; border-radius: 8px; cursor: pointer;')}>Somente essenciais</button>
          <button onClick={() => escolher('todos')} style={css('background: #F5A623; border: none; color: #0B1220; font-weight: 700; font-size: 13px; padding: 10px 18px; border-radius: 8px; cursor: pointer;')}>Aceitar todos</button>
        </div>
      </div>
    </div>
  )
}
